import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";
import { routes } from "src/constants/routes";
import { linkArtefactIconGreenSvg } from "src/constants/svg/link-artefact-iconSVG";
import { ArtefactType } from "src/models/models.model";

@Component({
  selector: "app-artifact-card",
  templateUrl: "./artifact-card.component.html",
  styleUrls: ["./artifact-card.component.scss"],
})
export class ArtifactCardComponent {
  readonly linkArtefactIconGreenSvg = linkArtefactIconGreenSvg;
  readonly artefactType = ArtefactType;
  readonly routes = routes;
  @Input() datasetListItem!: any;
  @Input() linkedArtefact: boolean = false;

  constructor(private router: Router) {}

  onDatasetClick(id: any) {
    this.router.navigate([`/admin/datasets/details/${id}`]);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
